export default {
    apiUrl: "https://unihub-test.uniqa.cz/hyperionapi/api",
    authUrl: "https://login-test.uniqa.cz/auth/realms/people/protocol/openid-connect",
    authRedirectUri: "https://unihub-test.uniqa.cz",
    damageReportUrl: "https://skody-t.uniqa.cz/form/redirect/",
    damageReportUrlBaseSK: "https://skody-t.uniqa.sk/",
    wsUrl: "wss://wsocket-test.uniqa.cz/messaging",
    envName: "-Test" 
}